import { Dialog, DialogType, DialogFooter, PrimaryButton, DefaultButton } from '@fluentui/react';
import { useIntl } from 'react-intl';
import styles from './DeleteDialog.module.scss';

interface DeleteDialogProps {
  hidden: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  itemCount: number;
  messageId?: string;
  titleId?: string;
  isDeletionInProgress?: boolean;
}

export const DeleteDialog: React.FC<DeleteDialogProps> = ({
  hidden,
  onDismiss,
  onConfirm,
  itemCount,
  messageId = 'common.delete.confirmMessage',
  titleId = 'common.delete.confirmTitle',
  isDeletionInProgress = false,
}) => {
  const intl = useIntl();

  const dialogContentProps = {
    type: DialogType.normal,
    title: intl.formatMessage({ id: titleId }),
    subText: intl.formatMessage({ id: messageId }, { count: itemCount }),
  };

  return (
    <Dialog
      hidden={hidden}
      onDismiss={onDismiss}
      dialogContentProps={dialogContentProps}
      modalProps={{
        isBlocking: true,
        styles: { main: styles.dialog },
      }}
    >
      <DialogFooter>
        <PrimaryButton onClick={onConfirm} text={intl.formatMessage({ id: 'common.delete' })} disabled={isDeletionInProgress} />
        <DefaultButton onClick={onDismiss} text={intl.formatMessage({ id: 'common.cancel' })} disabled={isDeletionInProgress} />
      </DialogFooter>
    </Dialog>
  );
};
